import { constants } from "../../../constants";

export default class RequestRegister {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.web.requestRegister();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            default:
                event["register"] = this._default;
        }

        return event;
    }
}
